// extracted by mini-css-extract-plugin
module.exports = {"mainBar":"CoursesT_mainBar__1e2yE","addCourseLink":"CoursesT_addCourseLink__2N-c0","coursesList":"CoursesT_coursesList__1c6bR"};